export default {
  inserted(el, binding, vnode) {
    const every: boolean = binding.arg === 'every';
    if (!vnode.context.$permissions(binding.value, every)) {
      vnode.elm.parentElement.removeChild(vnode.elm);
    }
  }
};
